import { DaoService } from "./DaoService";

export class TacheService extends DaoService {

    static CLASS_NAME = "App\\Models\\Tache";
    
    static getInstance() {
        return super.getInstance('tache');
    }

    all() {
        return TacheService.get(`${this.prefix}/all`);
    }

    search(data) {
        return TacheService.post(`${this.prefix}/search`, data);
    }

    changeStep(uid, data) {
        return TacheService.post(`${this.prefix}/${uid}/change-step`, data);
    }

    detach(uid) {
        return TacheService.post(`${this.prefix}/${uid}/detach`);
    }

    getResponsables(filters) {
        return TacheService.post(`${this.prefix}/responsables`, filters);
    }

}